import { render, staticRenderFns } from "./fuquan.vue?vue&type=template&id=06546f76&scoped=true&"
import script from "./fuquan.vue?vue&type=script&lang=js&"
export * from "./fuquan.vue?vue&type=script&lang=js&"
import style0 from "./fuquan.vue?vue&type=style&index=0&id=06546f76&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06546f76",
  null
  
)

export default component.exports